import { useApi } from "@/lib/api";
import { useSeo } from "@/lib/site";
import { PageIntro } from "@/components/site/PageIntro";
import { SituationSelector } from "@/components/home/SituationSelector";

export default function FindYourWay() {
  useSeo("Find Your Way", "Choose your situation and get compassionate guidance, next steps and trusted UK support.");
  const { data } = useApi("/pathways");
  return (
    <>
      <PageIntro eyebrow="Find Your Way" title="One step at a time." image="/images/path.jpg" imageAlt="Sunlight falling across a quiet woodland path" testId="find-your-way-intro">
        <p>When you're overwhelmed, it can be hard to know where to begin. Choose the situation closest to yours and we'll guide you through what might help, without asking you to sign up or share anything about yourself.</p>
        <p className="text-sm">This guidance is general information, not professional advice. It is written by Addiction &amp; Us.</p>
      </PageIntro>
      <SituationSelector pathways={data || []} testId="find-your-way-selector" />
    </>
  );
}
